module.exports = __webpack_public_path__ + "static/media/post3.04a241ac.jpeg";